import { useEffect, useState } from 'react';
import type { CheckoutIo } from '../model/checkout_env.js';
import type { CheckoutTripService } from '../model/checkout_source.js';

/** Os serviços JÁ comprados da viagem deste checkout (#3180), para o painel
 *  "Sua viagem" separar o que a viagem já tem do que está sendo solicitado
 *  agora.
 *
 *  Fail-soft integral — é a regra do card inteiro, não um detalhe: sem
 *  `tripId`, sem port, com a leitura no ar ou com ela falhando, devolve `[]` e
 *  o painel fica byte a byte o de antes. A compra nunca depende desta leitura;
 *  quem paga o preço de um erro aqui seria o checkout, que não tem nada a ver
 *  com ele. */
export function useCheckoutTripServices(
  io: CheckoutIo | null,
  tripId?: string,
): CheckoutTripService[] {
  // A viagem LIDA anda junto com a lista: o cartão afirma "já na viagem" sobre
  // a viagem do bloco, então uma lista de outra viagem (a de antes da troca de
  // `tripId`, ainda na tela enquanto a nova carrega) afirmaria isso sobre a
  // errada. Só a lista da viagem em questão sai daqui.
  const [loaded, setLoaded] = useState<{ tripId?: string; services: CheckoutTripService[] }>({
    services: [],
  });
  const read = io?.getTripServices;
  useEffect(() => {
    if (!tripId || !read) return undefined;
    let cancelled = false;
    void read(tripId)
      .then((services) => {
        if (!cancelled) setLoaded({ tripId, services });
      })
      .catch(() => {
        // Viagem ilegível é o caso comum, não a exceção (compra sem viagem,
        // trip-api fora): o painel segue com o carrinho.
        if (!cancelled) setLoaded({ tripId, services: [] });
      });
    return () => {
      cancelled = true;
    };
  }, [tripId, read]);
  return loaded.tripId === tripId ? loaded.services : [];
}
